import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Collapse as MuiCollapse } from '@material-ui/core';
const useStyles = makeStyles(function () {
  return {
    root: {
      opacity: 0,
      transition: 'opacity 0.25s cubic-bezier(0.215, 0.61, 0.355, 1), height 0.25s cubic-bezier(0.645, 0.045, 0.355, 1)'
    },
    entered: {
      opacity: 1
    }
  };
}, {
  name: 'PdsAccordionTransition'
});
function AccordionTransition(props) {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(MuiCollapse, Object.assign({}, props, {
    classes: classes
  }));
}
export default AccordionTransition;